/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-25 18:20:43
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-05 17:51:12
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductContent/CloneButton/index.tsx
 */
import React from 'react';
import Button from 'src/components/CloneButton';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { cloneProductContent } from '../slice';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';

const CloneBtn = (props) => {
  const { disabled } = props;

  const params: any = useParams();
  const { salesChannelProductUuid } = params;
  const _d = useDispatch();
  const handleOnClick = () => {
    _d(
      cloneProductContent({
        body: salesChannelProductUuid,
        params: {
          [EnumSalesChannelMultiLanguage.multiLanguageUsePrimaryLanguage]: true,
        },
      }),
    );
  };
  return <Button onClick={handleOnClick} disabled={disabled} />;
};
export default CloneBtn;
